import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { RootState } from 'appHooks'
import { emptySplitApi } from 'shared/store/emptyApi'
import { merge } from 'shared/utils/mergeObjects'
import { IPublicationsFilters } from '../../PublicationFIlters'
import { PublicationCatergory, PublicationStatus } from '../models/publication'

const initialState = {
  filters: {
    search: '',
    status: 'Aktive' as PublicationStatus,
    category: 'Alle kategorier' as PublicationCatergory,
  },
}

export const setPublicationsFiltersThunk = createAsyncThunk(
  'publications/setFilters',
  (filters: Partial<IPublicationsFilters>, thunkApi) => {
    thunkApi.dispatch(publicationSlice.actions.setFilters(filters))
    thunkApi.dispatch(emptySplitApi.util.invalidateTags(['GET_PUBLICATIONS']))
  }
)

const publicationSlice = createSlice({
  name: 'publications',
  initialState,
  reducers: {
    setFilters: (
      state,
      action: PayloadAction<Partial<IPublicationsFilters>>
    ) => {
      state.filters = merge(state.filters, action.payload)
    },
  },
})

export const getPublicationFilter = (state: RootState) =>
  state.publications.filters

export default publicationSlice
